export const isUsingPersistentQueryCache = JSON.parse(
  import.meta.env.VITE_USE_PERSISTED_QUERIES ?? false
)

export const replaySessionSampleRate = JSON.parse(
  import.meta.env.VITE_REPLAY_SESSION_SAMPLE_RATE ?? 0.1
)
